// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/SitepenLogo","root":"SitepenLogo-m__root__f52bc31k6aK"};